import { useState } from "react";
import { request, debounce } from "../utils/index";
import { emailRule, ERROR_MESSAGE } from "../const";
import { setSetting, send } from "../service";

export const ForgetPassword = () => {

    const [email, setEmail] = useState("")
    const [complete, setComplete] = useState(false)
    const [valid, setValid] = useState(false)
    const [loading, setLoading] = useState(false)

    function back() {
        setSetting({ isForgetPassword: false })
    }

    function checkEmail(email) {
        setComplete(!!email)
        setValid(emailRule.test(email))
        let element = document.getElementById(`lable-input-email-forget`)
        if (!email) {
            element.classList.add('input-requried')
            element.classList.remove('input-has', 'input-error')
        } else if (!emailRule.test(email)) {
            element.classList.add('input-error')
            element.classList.remove('input-requried', 'input-has')
        } else {
            element.classList.add('input-has')
            element.classList.remove('input-requried', 'input-error')
        }
        return !email || !emailRule.test(email)
    }

    function forgetPassword() {
        if (!checkEmail) { return }
        setLoading(true)

        function reslove(res) {
            setLoading(false)
            if (res.code === 200) {
                send({
                    action: 'apiMessage',
                    type: "success",
                    message: "Send successfully"
                })
            } else {
                send({
                    action: 'apiMessage',
                    type: "error",
                    message: !res.message || res.message === "email error" ? "The account entered doesn't exist. Please enter a correct email address." : res.message
                })
            }
        }
        function timeoutCb(){
            setLoading(false)
            send({ action: 'apiMessage', type: "error", message: ERROR_MESSAGE })
        }
        debounce(() => {
            request({
                url: 'fleet/forgetPass?email=' + email,
                method: 'get',
                reslove: reslove,
                timeoutCb
            })
        }, 10, true)
    }
    const disabled = !(emailRule.test(email) && email)

    return (<div style={{
        width: 290, padding: "32px",
        position: "relative",
        background: "#fff",
        height: 466,
        boxSizing: "border-box",
        borderRadius: 8,
        width: 354,
        boxShadow: "0px 4px 10px -2px rgba(16, 24, 40, 0.1), 0px 0px 4px -2px rgba(16, 24, 40, 0.05)"
    }}>
        <div className="right-title" style={{ margin: "4px 0" }}>Forgot your password?</div>
        <div className="right-subTitle" style={{ marginTop: 4,margin: "auto" }}>Enter the email address associated with your Enterprise Account and get instructions to reset your password.</div>
        <div style={{ position: "relative" }} className="each-input-con">
            <input className="input email" autoComplete="new-password" hidden
                onInput={(e) => {
                    setEmail(e.target.value)
                    checkEmail(e.target.value.trim(), "noFalse")
                }}
                onBlur={e => {
                    setEmail(e.target.value.trim())
                    checkEmail(e.target.value.trim())
                }}
                maxLength="512" id="lable-input-email-forget" />
            <label htmlFor="lable-input-email-forget" className="input-label">Email Address</label>
            {!complete && <div className="form-error form-requried"
                style={{ visibility: "visible!important" }}>Please complete this required field</div>}
            {complete && !valid && <div className="form-error" style={{ visibility: "visible" }}>Invalid email format</div>}
        </div>
        {loading ? <div className="common-loading submit-btn">
            <div className="loading-icon"></div>
        </div> :
            <div className="submit-btn" id="submit-btn-forget" onClick={forgetPassword}
                style={{ background: !disabled ? "#4066D4" : "#DADCE1", marginTop: 24, cursor: !disabled ? "pointer" : "not-allowed" }}>
                SEND EMAIL
            </div>}
        <div className="back-login" onClick={back} >  <img src="./images/ArrowLeft.svg" alt="" />&nbsp;&nbsp;Back to log in</div>
    </div>)
}